import React, { Component } from 'react';
import { Button, Modal, Table, Spinner } from 'react-bootstrap';
import { ReactComponent as TranslateIcon } from '../../../assets/images/ui/ic-translation.svg';
import { api } from '../../api';
import { DeleteTranslation } from './DeleteTranslation';
export class ChapterTranslateBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTranslating: false,
      showModal: false,
      translations: [],
      isLoadingTranslations: false,
      showDeleteModal: false,
      translationToDelete: null,
    };
  }

  async loadAvailableTranslations() {
    const { book, obj: episode } = this.props;
    this.setState({ isLoadingTranslations: true });

    try {
      const { data } = await api.get(`/v1/stories/${episode.id}/availableLanguages`);
      this.setState({ translations: data.translations ?? [] }); // ✅ extract correct array
    } catch (err) {
      console.error('Failed to load available translations:', err);
      this.setState({ translations: [] });
    } finally {
      this.setState({ isLoadingTranslations: false });
    }
  }
  async translateEpisode(bookId, episodeId, force = false) {
    this.setState({ isTranslating: true });
    try {
      await api.post(`/v1/books/${bookId}/chapters/${episodeId}/translate`, null, {
        params: { force },
      });
      // ✅ Reload translations after the refresh finishes
      await this.loadAvailableTranslations();
    } catch (err) {
      console.error('Translation failed:', err);
    } finally {
      this.setState({ isTranslating: false });
    }
  }
  openModal = () => {
    this.setState({ showModal: true }, () => {
      this.loadAvailableTranslations().then();
    });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };
  openDeleteModal = (translation) => {
    this.setState({
      showDeleteModal: true,
      translationToDelete: translation,
    });
  };
  closeDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      translationToDelete: null,
    });
  };
  
  
  render() {
    const { obj: episode, book, disabled } = this.props;
    const {
      isTranslating,
      showModal,
      translations,
      isLoadingTranslations,
      showDeleteModal,
      translationToDelete,
    } = this.state;

    return (
      <>
        <span className="tooltip-box">
          <Button
            disabled={disabled || isTranslating}
            onClick={this.openModal}
            variant="secondary"
            size="sm"
            className="ml-1"
          >
            {isTranslating ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <TranslateIcon className="btnImg" style={{ color: '#b43434' }} />
            )}
          </Button>
          <div className="tooltip">
            <div className="arrow" />
            <div className="tooltip-inner">Refresh Translations</div>
          </div>
        </span>

        <Modal show={showModal} onHide={this.closeModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Available Translations of {episode.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoadingTranslations ? (
              <div className="text-center">
                <Spinner animation="border" />
              </div>
            ) : (
              <Table striped bordered hover size="sm">
                <thead>
                <tr>
                  <th>Id</th>
                  <th>Revision</th>
                  <th>Language</th>
                  <th>Available</th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {translations.map((t, index) => (
                  <tr key={t.id ?? `missing-${index}`}>
                    <td>{t.id ?? '-'}</td>
                    <td>{t.revision ?? '-'}</td>
                    <td>
                      {t.language?.code
                        ? `(${t.language.code}) ${t.language.name}`
                        : '-'}
                    </td>
                    <td>{t.available ? 'Yes' : 'No'}</td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        disabled={!t.available || isTranslating}
                        onClick={() => this.openDeleteModal(t)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
                </tbody>
              </Table>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Close
            </Button>
            <Button
              variant="primary"
              disabled={isTranslating || !book.aiAllowed}
              onClick={() =>
                this.translateEpisode(book.id, episode.id, false)
              }
            >
              {isTranslating ? (
                <>
                  <Spinner animation="border" size="sm" className="mr-2" />
                  Refreshing...
                </>
              ) : (
                'Refresh Translations'
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* confirmation modal for deleting one translation */}
        {showDeleteModal && translationToDelete && (
          <DeleteTranslation
            show={true}
            match={this.props.match}
            obj={{
              id: translationToDelete.id,
              title: translationToDelete.language?.name,
            }}
            update={() => this.loadAvailableTranslations()}
            onHide={this.closeDeleteModal}
          />
        )}
      </>
    );
  }
}